import { createContext, useContext, useEffect, useRef, useState } from "react";

const ServerStatusContext = createContext({});

const FAILURE_THRESHOLD = 2;
const RECOVERY_RESET_MS = 30000; // 30 sn boyunca hata yoksa sıfırla

export const ServerStatusProvider = ({ children }) => {
  const [serverDown, setServerDown] = useState(false);
  const [offline, setOffline] = useState(!navigator.onLine);
  const failureCount = useRef(0);
  const recoveryTimer = useRef(null);

  // Internet bağlantısı takibi
  useEffect(() => {
    const handleOnline = () => setOffline(false);
    const handleOffline = () => setOffline(true);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  // Server-unreachable event dinle (baseQueryWithReauth'dan gelir)
  useEffect(() => {
    const handleServerUnreachable = () => {
      failureCount.current += 1;
      if (failureCount.current >= FAILURE_THRESHOLD) {
        setServerDown(true);
      }
      // Recovery timer'ı sıfırla
      clearTimeout(recoveryTimer.current);
    };

    window.addEventListener("server-unreachable", handleServerUnreachable);
    return () => {
      window.removeEventListener("server-unreachable", handleServerUnreachable);
    };
  }, []);

  // Başarılı API yanıtlarını dinle — server tekrar erişilebilir
  useEffect(() => {
    const handleApiSuccess = () => {
      failureCount.current = 0;
      setServerDown(false);
      clearTimeout(recoveryTimer.current);
    };

    window.addEventListener("api-success", handleApiSuccess);
    return () => {
      window.removeEventListener("api-success", handleApiSuccess);
    };
  }, []);

  return (
    <ServerStatusContext.Provider value={{ serverDown, offline }}>
      {children}
    </ServerStatusContext.Provider>
  );
};

export const useServerStatus = () => {
  const context = useContext(ServerStatusContext);
  if (!context) {
    throw new Error("useServerStatus must be used within ServerStatusProvider");
  }
  return context;
};

export default ServerStatusContext;
